// File: /src/utils/financeMetrics.js

const toNumber = (value) => {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : 0;
};

export const calculateFinanceKPIs = (summary = {}) => {
	const totalIncome = toNumber(summary.totalIncome);
	const totalExpense = toNumber(summary.totalExpense);
	const totalReceived = toNumber(summary.totalReceived);
	const totalPending = toNumber(summary.totalPending);
	const totalOverdue = toNumber(summary.totalOverdue);

	const totalRevenue = totalIncome + totalReceived;
	const totalInvoices = totalReceived + totalPending + totalOverdue;

	const operationalMargin =
		totalRevenue > 0
			? ((totalRevenue - totalExpense) / totalRevenue) * 100
			: 0;
	const invoiceConversionRate =
		totalInvoices > 0 ? (totalReceived / totalInvoices) * 100 : 0;
	const defaultRate =
		totalInvoices > 0 ? (totalOverdue / totalInvoices) * 100 : 0;
	const expenseRatio =
		totalRevenue > 0 ? (totalExpense / totalRevenue) * 100 : 0;
	const pendingRatio =
		totalInvoices > 0 ? (totalPending / totalInvoices) * 100 : 0;
	const liquidityRatio = totalExpense > 0 ? totalRevenue / totalExpense : 0;
	const dailyAverageRevenue = totalRevenue / 30;

	return {
		revenueTotal: totalRevenue,
		operationalMargin,
		invoiceConversionRate,
		defaultRate,
		expenseRatio,
		pendingRatio,
		liquidityRatio,
		dailyAverageRevenue,
	};
};

export const buildFinancePieData = (summary = {}) => {
	const totalIncome = toNumber(summary.totalIncome);
	const totalReceived = toNumber(summary.totalReceived);
	const totalExpense = toNumber(summary.totalExpense);
	const totalOverdue = toNumber(summary.totalOverdue);

	return [
		{ key: 'income', name: 'Receitas', value: totalIncome },
		{ key: 'received', name: 'Faturas Pagas', value: totalReceived },
		{ key: 'expense', name: 'Despesas', value: totalExpense },
		{ key: 'overdue', name: 'Faturas Atrasadas', value: totalOverdue },
	];
};

const formatPeriodLabel = (date, period) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');

	if (period === 'monthly') {
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	}

	return `${year}-${month}`;
};

export const buildLineSeriesByPeriod = (entries = [], period = 'monthly') => {
	const grouping = {};

	entries.forEach((entry) => {
		if (!entry?.date) return;
		const parsedDate = new Date(entry.date);
		if (Number.isNaN(parsedDate.getTime())) return;

		const label = formatPeriodLabel(parsedDate, period);

		if (!grouping[label]) {
			grouping[label] = {
				income: 0,
				expense: 0,
				paid: 0,
				pending: 0,
				overdue: 0,
			};
		}

		const numericValue = toNumber(entry.value);

		switch (entry.type) {
			case 'income':
				grouping[label].income += numericValue;
				break;
			case 'expense':
				grouping[label].expense += numericValue;
				break;
			case 'paid':
				grouping[label].paid += numericValue;
				break;
			case 'pending':
				grouping[label].pending += numericValue;
				break;
			case 'overdue':
				grouping[label].overdue += numericValue;
				break;
			default:
				break;
		}
	});

	return Object.keys(grouping)
		.sort()
		.map((label) => ({
			month: label,
			...grouping[label],
		}));
};
